import React from 'react';
import { connectMenu } from 'react-instantsearch-dom';
import classnames from 'classnames';

const MenuSelect = ({
  items,
  currentRefinement,
  refine,
  id,
  name,
  label,
  emptyOptionLabel,
  className
}) => (
  <div className={classnames('form__field', className)}>
    {(label || emptyOptionLabel) && (
      <label className="form__label u--visible-sr">
        {label || emptyOptionLabel}
      </label>
    )}
    <div className="form__select form__select--alt form__select--lg">
      <select
        id={id || name}
        name={name}
        value={currentRefinement || ''}
        onChange={(event) => refine(event.currentTarget.value)}
      >
        <option value="">{emptyOptionLabel}</option>
        {items.map((item) => (
          <option
            key={item.label}
            value={item.isRefined ? currentRefinement : item.value}
          >
            {item.label}
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default connectMenu(MenuSelect);
